import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { create, updateAction } from "../../../store/actions/CommonActions";
import AddUpdateUI from "./AddUpdateUI.jsx";
import {
    getCategories,
    // getGenre,
    getInitiatives,
} from "../../../services/CommonServices";
import { apiCaller } from "../../../services/AxiosInstance.js";
import Swal from "sweetalert2";
import { scheduleValidationSchema } from "../../../utils/validationSchemas/MasterDataSchema.js";
import AddUpdateSchedule from "../Schedule/AddUpdate.jsx";
import { validateScheduleTime } from "../Projects/ProjectArtistShow.jsx";
import FormHandler from "../../components/Forms/FormHandler.jsx";
import PageTitle from "../../layouts/PageTitle.js";

const AddUpdateShows = () => {
    const { state } = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showData, setShowData] = useState(state ?? {});

    useEffect(() => {
        refetchData();
    }, []);
    const refetchData = async () => {
        if (showData._id) {
            try {
                const response = await apiCaller({ url: `schedule/${showData._id}` }).then(
                    (response) => response?.data?.data
                );
                setShowData(response);
            } catch (error) { }
        }
    };

    const handleSubmit = () => {
        navigate("/shows", { replace: true });
    };


    const scheduleModalConfig = {
        initialValues: {
            _id: showData?._id,
            showName: showData?.project?.conceptTitle,
            initiative: showData?.initiative?._id,
            venue: showData?.venue?._id,
            performanceVenue: showData?.performanceVenue?._id,
            date: showData?.date,
            start_time: showData?.start_time,
            end_time: showData?.end_time,
            pre_booking: showData?.pre_booking,
            pre_booking_percentage: showData?.pre_booking_percentage || 10,
            //   show: state?._id,
            project: showData?.project?._id,
            pre_booking_entry_only: showData?.pre_booking_entry_only,
        },
        validationSchema: scheduleValidationSchema,
        apiUrl: "schedule",
        FormComponent: AddUpdateSchedule,
        addTitle: `Schedule the Show for`,
        subTitle: showData?.project?.conceptTitle,
        updateTitle: "Update Schedule",
        extraProps: {
            ...showData,
            validate: validateScheduleTime,
        },
    };

    return (
        <>
            <PageTitle
                activeMenu="Shows"
                motherMenu="Form"
                pageContent="Show Details"
            />
            <div className="col-6 container-mxw">

                <FormHandler
                    modalConfig={{
                        ...scheduleModalConfig,
                        handleSubmit
                    }}
                />
            </div>
        </>
    );
};

export default AddUpdateShows;
